import { createTheme } from "@mui/material/styles";

const muiTheme = createTheme({
  palette: {
    primary: {
      main: "#1a1a1a", // Soft Black
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#D4AF37", // Premium Gold
      contrastText: "#000000",
    },
    background: {
      default: "#f8f9fa",
      paper: "#ffffff",
    },
    text: {
      primary: "#1a1a1a",
      secondary: "#4b5563",
    },
    action: {
      active: "#D4AF37",
      hover: "rgba(212, 175, 55, 0.08)",
      selected: "rgba(212, 175, 55, 0.16)",
    },
  },
  typography: {
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    button: { fontWeight: 600, textTransform: "none" },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          boxShadow: "none",
          "&:hover": {
            boxShadow:
              "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
          },
        },
        containedPrimary: {
          backgroundColor: "#1a1a1a",
          color: "#ffffff",
          "&:hover": { backgroundColor: "#333333" },
        },
        containedSecondary: {
          backgroundColor: "#D4AF37",
          color: "#000000",
          "&:hover": { backgroundColor: "#b5952f" },
        },
        outlinedPrimary: {
          borderColor: "#1a1a1a",
          color: "#1a1a1a",
          "&:hover": {
            backgroundColor: "#1a1a1a",
            color: "#ffffff",
            borderColor: "#1a1a1a",
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
          border: "1px solid rgba(0,0,0,0.05)",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#e5e7eb",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#D4AF37",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#D4AF37",
            borderWidth: 2,
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          "&.Mui-focused": {
            color: "#D4AF37",
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#ffffff",
          color: "#1a1a1a",
          boxShadow:
            "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: "#1a1a1a",
          color: "#ffffff",
          borderRight: "none",
        },
      },
    },
  },
});

export default muiTheme;
